import axios from 'axios'
import store from '@/store'

const BASE_OPT = {
  timeout: 8000 // 请求超时时间 8秒
}
// axios.defaults.withCredentials = true
const $http = axios.create({
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  baseURL: '/sweb/'
});
$http.interceptors.response.use(
  (response => response.data)
);
const create = (opt) => {

  window._api = {$http, axios}
  const service = axios.create({
    ...BASE_OPT,
    ...opt
  })
  // 请求头携带当前页面的supplierId
  service.interceptors.request.use(req => {
    // 请求劫持 头部绑定携带 aph_key
    if (process.env.NODE_ENV === 'development') {
      req.headers['aph_key'] = process.env.aph_key
    }
    if (store && store.getters && store.getters.loginSupplier && store.getters.loginSupplier.id) {
      req.headers['header-supplier'] = store.getters.loginSupplier.id
    }
    return req
  })

  // 接口返回错误格式则拦截 错误格式：无ret & 无error字段 PS:
  service.interceptors.response.use(res => {
    let d = res.data || {}
    if (d.ret === 1 && (d.data || d.data === 0 || d.rows)) {
      return res
    } else if (d.ret === 1 && !d.error && !d.data && !d.rows) {
      return {
        data: {
          ret: 1,
          data: null
        }
      }
    } else {
      // 原代码store中（接口处理）有误，但因错误代码量太多，则统一在这里劫持处理
      // 没有throw Error 就是当出现错误接口时，不推到catch中
      return {
        data: {
          error: d
        }
      }
    }
  })
  // console.log(service, 'service')
  return service
}


export default {
  create,
  $http
}



// WEBPACK FOOTER //
// ./src/api/base.js